import type { User } from "../types/api";

export function isEmailVerified(user: User | null | undefined): boolean {
  if (!user) return false;
  if (user.auth_provider === "google") return true;
  return !!user.email_verified_at;
}

export function isPhoneVerified(user: User | null | undefined): boolean {
  if (!user) return false;
  return !!user.phone_verified_at;
}

export function isIdentityVerified(user: User | null | undefined): boolean {
  if (!user) return false;
  if (user.auth_provider === "google") return isPhoneVerified(user);
  return isEmailVerified(user) && isPhoneVerified(user);
}
